export default (positionPercentage) => {
  const verticalScrollMax = document.body.clientHeight - window.innerHeight;
  const horizontalScrollMax = document.body.clientWidth - window.innerWidth;
  window.scrollTo(((horizontalScrollMax * positionPercentage) / 100), ((verticalScrollMax * positionPercentage) / 100));
};



// WEBPACK FOOTER //
// ./src/components/Parallax/utils/scrollToPosition.js